import * as React from 'react';

import {DateTimePickerPopover} from '../../../date-time-picker/date-time-picker-popover';
import {FormattedTimestamp} from '../../../timestamp/formatted-timestamp';
import {Body} from '../../../typography/body';

type Props = {
    date: number | null | undefined;
    placeholder: string | null | undefined;
    onUpdateDate: (date?: string | null | undefined) => void;
    isEditing: boolean;
    setIsEditing: (isEditing: boolean) => void;
};

export function DateCustomField(props: Props) {
    const datePickerRef = React.useRef<HTMLDivElement | null | undefined>(null);

    const handleUpdateDate = (date?: Date | null) => {
        props.setIsEditing(false);
        props.onUpdateDate(date ? date.toISOString() : null);
    };

    return (
        <>
            {/* @ts-expect-error */}
            <div ref={datePickerRef}>
                {props.date ? (
                    <FormattedTimestamp
                        datetime={props.date}
                        format={FormattedTimestamp.formats.longMonthDayWithYear}
                    />
                ) : (
                    <Body size='small' color='light'>
                        {props.placeholder}
                    </Body>
                )}
            </div>
            {props.isEditing && datePickerRef.current && (
                <DateTimePickerPopover
                    anchor={datePickerRef.current}
                    shouldOmitTime={true}
                    value={props.date ? new Date(props.date * 1000) : new Date()}
                    onCancel={() => props.setIsEditing(false)}
                    onConfirm={handleUpdateDate}
                    onClear={props.date ? () => handleUpdateDate(null) : undefined}
                />
            )}
        </>
    );
}
